export const BROKER_ASSOCIATIONS = 'BROKER_ASSOCIATIONS';
export const BROKER_ASSOCIATIONS_FAILED = 'BROKER_ASSOCIATIONS_FAILED';
export const SG_MIGRATION_TABLE = 'SG_MIGRATION_TABLE';
export const SG_MIGRATION_TABLE_FAILED = 'SG_MIGRATION_TABLE_FAILED';
export const RENEWAL_MIGRATION_CONFIG_DATA_SUCESS = 'RENEWAL_MIGRATION_CONFIG_DATA_SUCESS';
export const RENEWAL_MIGRATION_CONFIG_DATA_FAILED = 'RENEWAL_MIGRATION_CONFIG_DATA_FAILED';
export const QUOTES_SET_USER_NPN = 'QUOTES_SET_USER_NPN';
